import {Observer} from "mobx-react";
import {useEffect, useReducer} from "react";
import {PortfolioAvatar} from "../PortfolioAvatar";
import {DropdownButtonV5} from "../interaction/DropdownButtonV5";
import {useAppStore} from "../../../StateManager";
import {HorizontalAlignment, VerticalAlignment} from "../../../utils/dom/DomUtils";
import type {Portfolio} from "../../../data/models/Portfolio";
import {XyiconFeature} from "../../../generated/api/base";
import {navBarZIndex} from "../styles/styles";
import {StringUtils} from "../../../utils/data/string/StringUtils";
import {openWorkspaceFromPortfolioModule} from "../modules/ActionBarUtils";

export const PortfolioSelector = () => {
	const appState = useAppStore((state) => state.appState);
	const navBarState = useAppStore((state) => state.navBarState);
	const [, forceUpdate] = useReducer((x) => x + 1, 0);
	const authDataUpdatedSignal = appState.app.transport.services.auth.signals.authDataUpdated;

	useEffect(() => {
		authDataUpdatedSignal.add(forceUpdate);

		return () => {
			authDataUpdatedSignal.remove(forceUpdate);
		};
	}, [authDataUpdatedSignal]);

	return (
		<Observer>
			{() => {
				const portfolios = appState.actions
					.getList<Portfolio>(XyiconFeature.Portfolio)
					.toSorted((a: Portfolio, b: Portfolio) => StringUtils.sortIgnoreCase(a.name, b.name));

				const relevantPortfolioId = appState.relevantPortfolioId;
				const item = appState.actions.getPortfolioById(relevantPortfolioId);
				const itemType = appState.actions.getTypeById(item?.typeId);
				const color = itemType?.settings.color.hex || "FFFFFF";

				if (!portfolios.length) {
					return null;
				}

				const activeOption = portfolios.filter((p) => p.id === appState.relevantPortfolioId).map((p) => ({label: p.name}));

				return (
					<DropdownButtonV5
						button={
							<PortfolioAvatar
								name={(appState.actions.getPortfolioById(relevantPortfolioId)?.name || "").trim()}
								thumbnailOnly={navBarState === "closed"}
								color={color}
							/>
						}
						className="portfolioSelector"
						optionsZIndex={navBarZIndex + 1}
						options={portfolios.map((p) => ({
							label: p.name,
							onClick: () => openWorkspaceFromPortfolioModule(appState, p.id),
							isActive: p.id === appState.relevantPortfolioId,
						}))}
						verticalAlignment={VerticalAlignment.bottom}
						horizontalAlignment={HorizontalAlignment.outerRight}
						offsetX={12}
						offsetY={0}
						width="272px"
						showSearch={true}
						closeOnMouseLeave={true}
						activeOption={activeOption}
						style={{overflowX: "hidden"}}
						isPortfolioSwitch={true}
					/>
				);
			}}
		</Observer>
	);
};
